import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useWatch } from 'react-hook-form';

import HookFormTextField from 'reservations/form/components/HookFormTextField';

function NotesFormField() {
  const note = useWatch({
    name: 'note'
  });
  const [isNoteOpen, setIsNoteOpen] = useState(!!note);

  return (
    <>
      {!isNoteOpen ? (
        <Typography
          onClick={() => setIsNoteOpen(true)}
          sx={{ fontWeight: '700', fontSize: '15px' }}
        >
          + ADD A NOTE
        </Typography>
      ) : (
        <HookFormTextField
          multiline
          dataTestId="notes-form-field"
          name="note"
          label="Notes"
          rows={2}
          placeholder="Please be aware that special requests are not guaranteed"
        />
      )}
    </>
  );
}

export default NotesFormField;
